import { Footer } from "@components/site/Footer"
import { Header } from "@components/site/Header"
import { RouteDisplay, ScrollRestoration, useRoute, useRouterState, useRouteTransition } from "eddev/routing"
import { defineView } from "eddev/views"
import { PageProvider, usePageContext } from "../contexts/PageContext"
import { AnimatePresence, motion, number, stagger } from "motion/react"
import { useEffect, useRef } from "react"
import { StaggerTransitionRoot } from "@components/motion/Transitioned"
import { cn } from "@utils/tw"

export default defineView("_app", (props) => {
  const route = useRoute()

  const pendingScroll = useRef<null | { top: number }>()

  return (
    <PageProvider>
      <ScrollRestoration
        restore={(state) => {
          pendingScroll.current = state
        }}
      />
      <InnerApp>
        <Header />
        <AnimatePresence
          mode="wait"
          initial={false}
          onExitComplete={() => {
            if (pendingScroll.current) {
              document.scrollingElement?.scrollTo({
                top: pendingScroll.current.top,
                behavior: "instant",
              })
              pendingScroll.current = null
            }
          }}
          propagate
        >
          <StaggerTransitionRoot key={route.id}>
            <RouteDisplay route={route} />
            <Footer />
          </StaggerTransitionRoot>
        </AnimatePresence>
      </InnerApp>
    </PageProvider>
  )
})

const InnerApp = ({ children }: { children: React.ReactNode }) => {
  const { introLogoPlaying } = usePageContext()
  const route = useRoute()
  const isHomepage = route.pathname === "/"

  return <div className={cn("w-full", introLogoPlaying && isHomepage && "h-[100vh] overflow-hidden")}>{children}</div>
}
